export const GET_ALL_KEYCODES = 'GET_ALL_KEYCODES';
export const EDIT_KEYCODE_BY_ID = 'EDIT_KEYCODE_BY_ID';
export const SAVE_EDIT_KEYCODE = 'SAVE_EDIT_KEYCODE';
export const DELETE_KEYCODE = 'DELETE_KEYCODE';
export const RESET_KEYCODE_PASSWORD = 'RESET_KEYCODE_PASSWORD';
export const SAVE_KEYCODE = 'SAVE_KEYCODE';
export const DELETE_KEYCODE_ID = 'DELETE_KEYCODE_ID';
export const RELEASE_KEYCODE = 'RELEASE_KEYCODE';

